var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-top",class:{'not-share':!_vm.share}},[_c('el-backtop',{attrs:{"bottom":-1,"right":0,"visibility-height":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }